module.exports = __webpack_public_path__ + "media/images/icons/outlined/rise-ce11276e7d19661ae95f39aaa10d6f4e.svg";